$(document).ready(function () {

	$('.hero').not('.slick-initialized').slick(
	  {
		  arrows: false,
		  dots: false,
		  infinite: true,
		  autoplay: true,
		  cssEase: 'linear',
		  speed: 900,
		  autoplaySpeed: 4000,
		  pauseOnHover: false,
		  pauseOnFocus: false,
		  adaptiveHeight: false,
	  });

		$('.testimonial-carousel').not('.slick-initialized').slick(
			{
				arrows: true,
				dots: false,
				infinite: true,
				autoplay: true,
				cssEase: 'linear',
				speed: 900,
				autoplaySpeed: 4000,
				pauseOnHover: false,
				pauseOnFocus: false,
				adaptiveHeight: false,
			});


			$('.menu-btn').click(function(){
				$('.main-nav-mobile ul').addClass('active');
			});

			$('.close-menu').click(function(){
				$('.main-nav-mobile ul').removeClass('active');
			});

});
